import React, { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [adminUser, setAdminUser] = useState(null);
  const [adminToken, setAdminToken] = useState(localStorage.getItem('med_admin_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      const token = localStorage.getItem('med_admin_token');
      if (!token) { setLoading(false); return; }
      try {
        const res = await fetch(`${API}/api/auth/admin-me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setAdminUser(data);
          setAdminToken(token);
        } else {
          localStorage.removeItem('med_admin_token');
          setAdminToken(null);
        }
      } catch {
        localStorage.removeItem('med_admin_token');
        setAdminToken(null);
      }
      setLoading(false);
    };
    verify();
  }, []);

  const adminLogin = async (pin) => {
    const res = await fetch(`${API}/api/auth/admin-login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Invalid PIN');
    localStorage.setItem('med_admin_token', data.token);
    setAdminToken(data.token);
    setAdminUser({ admin: data.admin, display_name: data.display_name });
    return data;
  };

  const logout = () => {
    localStorage.removeItem('med_admin_token');
    setAdminToken(null);
    setAdminUser(null);
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated: !!adminUser,
      adminUser,
      adminToken,
      adminLogin,
      logout,
      loading,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
